module.exports = __webpack_public_path__ + "img/host.light.8c1b8ee0.svg";